
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/communities",
      function () {
        return require("private-next-pages/partners/communities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/communities"])
      });
    }
  